
import { Base } from '../base-component';

import './branch-locator-item.component.scss';

export class BranchLocatorItem extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}



// WEBPACK FOOTER //
// ./components/branch-locator-item/branch-locator-item.component.ts